"use strict";

import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import SchoolForm from "./SchoolForm";
import { AlertActions } from "../../../actions";

class EduModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      index: 0
    }
  }

  render() {
    const { show, onCancel, title, createNew, selectedMentor } = this.props;
    const { index: mainIndex } = this.state;

    let schools = selectedMentor && selectedMentor.schools, school = null;

    if(schools && !createNew) {
      const index = this._findIndexBySchoolInUser();
      school = schools[index];
    }

    return (
      <Modal size="lg" show={show} backdrop={true}>
        <Modal.Header closeButton={true} onHide={onCancel}>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            createNew && (
              <div className="form-group">
                <label>After</label>
                <select 
                  value={mainIndex}
                  className="form-control" 
                    onChange={e => {
                    this.setState({ index: e.target.value })
                  }}
                >
                  {
                   (schools || []).map((school, index) => {
                     const name = school.org && school.org.name || school.orgWithoutUrl;
                    return (<option key={school._id} value={index}>{`${index+1}- ${name}`}</option>);                     
                   }) 
                  }
                </select>
              </div>
            )
          }
          <SchoolForm  
            onSubmit={this._handleSubmit} 
            onCancel={onCancel}
            school={school}
          />
        </Modal.Body>
      </Modal>
    )
  }
  
  _handleSubmit = obj => {
    const { org, degree, grade, major, attended: { start = "", end = "", isCurrent = "" } = {} } = obj;
    const { createNew } = this.props;

    if(!org) return AlertActions.error({ message: "Organization cannot be empty" });
    if(!degree) return AlertActions.error({ message: "Degree cannot be empty" });
    if(!major) return AlertActions.error({ message: "Major cannot be empty" });
    if(!grade) return AlertActions.error({ message: "Grade cannot be empty" });
    if(!start) return AlertActions.error({ message: "Starting year cannot be empty" });
    if(!end && !isCurrent) return AlertActions.error({ message: "Ending year cannot be empty" });
    
    let { index } = this.state;
    if(!createNew) index = this._findIndexBySchoolInUser();
    
    console.log("index", index);
    this.props.onSave(obj, createNew, index, "schools");
  }

  _findIndexBySchoolInUser = () => {
    const { selectedMentor: { schools = [], schoolInUser = null } } = this.props;
    if(schoolInUser) {
      for(let i=0; i<schools.length; i++)
        if(schools[i]._id === schoolInUser) return i;
    }
    return 0;
  }
}

export default EduModal;